import { secureDelete, secureGet, securePost, securePut } from "../../Config/ApiConfig";


export const getAgents = async ({ page, size, search }) => {
    const { data } = await secureGet(`/agents?page=${page}&per_page=${size}${search ? "&search_string=" + search : ''}`);
    return data;
};

export const createOrUpdateAgent = async (body) => {
    const { data } = (body?.id ? await securePut('/agents/' + body.id, body) : await securePost('/agents', body));
    return data;
};
export const deleteAgent = async (id) => {
    const { data } = await secureDelete('/agents/' + id);
    return data;
};

export const getPlatforms = async ({ page, size }) => {
    const { data } = await secureGet(`/auth-platforms/facebook_page/resources?sort_by=name&sort_direction=asc&page=${page}&per_page=${size}`);
    return data;
};

export const connectToAuth = async (access_token) => {
    const { data } = await securePost('/auth-platforms/facebook_page', { short_lived_token: access_token });
    return data;
};

export const getAgentContacts = async ({id, page, size, search}) => {
    const { data } = await secureGet(`/agents/${id}/contacts?page=${page}&per_page=${size}&${search ? "&search_string=" + search : ''}`);
    return data;
};

